/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JWTClaims
 */
export interface JWTClaims {
    /**
     * 
     * @type {string}
     * @memberof JWTClaims
     */
    aud?: string;
    /**
     * 
     * @type {string}
     * @memberof JWTClaims
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof JWTClaims
     */
    iat?: number;
    /**
     * 
     * @type {number}
     * @memberof JWTClaims
     */
    exp?: number;
    /**
     * 
     * @type {number}
     * @memberof JWTClaims
     */
    nbf?: number;
    /**
     * 
     * @type {string}
     * @memberof JWTClaims
     */
    iss?: string;
    /**
     * 
     * @type {string}
     * @memberof JWTClaims
     */
    sub?: string;
}

/**
 * Check if a given object implements the JWTClaims interface.
 */
export function instanceOfJWTClaims(value: object): value is JWTClaims {
    return true;
}

export function JWTClaimsFromJSON(json: any): JWTClaims {
    return JWTClaimsFromJSONTyped(json, false);
}

export function JWTClaimsFromJSONTyped(json: any, ignoreDiscriminator: boolean): JWTClaims {
    if (json == null) {
        return json;
    }
    return {
        
        'aud': json['aud'] == null ? undefined : json['aud'],
        'id': json['id'] == null ? undefined : json['id'],
        'iat': json['iat'] == null ? undefined : json['iat'],
        'exp': json['exp'] == null ? undefined : json['exp'],
        'nbf': json['nbf'] == null ? undefined : json['nbf'],
        'iss': json['iss'] == null ? undefined : json['iss'],
        'sub': json['sub'] == null ? undefined : json['sub'],
    };
}

export function JWTClaimsToJSON(json: any): JWTClaims {
    return JWTClaimsToJSONTyped(json, false);
}

export function JWTClaimsToJSONTyped(value?: JWTClaims | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aud': value['aud'],
        'id': value['id'],
        'iat': value['iat'],
        'exp': value['exp'],
        'nbf': value['nbf'],
        'iss': value['iss'],
        'sub': value['sub'],
    };
}

